import { render, staticRenderFns } from "./VideoLists.vue?vue&type=template&id=25bccc0a&scoped=true&"
import script from "./VideoLists.vue?vue&type=script&lang=js&"
export * from "./VideoLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bccc0a",
  null
  
)

export default component.exports